/**
 * T-Menu Active Shield Script
 * This monitors the third-party menu app for inline style injections 
 * and overrides them in real-time.
 */
(function() {
    // 1. CONFIGURATION: Matches the 155.5px from your specific CSS
    const HEADER_HEIGHT = '155.5px'; 
    const MENU_SELECTOR = '.mpd-mg .tmenu_submenu_mega_fullscreen';
    const MIN_WIDTH = 990;

    const forceStyle = (el) => {
        if (el) {
            // Check if we are on desktop (>= 990px) as per your @media rule
            if (window.innerWidth >= MIN_WIDTH) {
                // Overwrite the app's inline !important height
                el.style.setProperty('height', `calc(100vh - ${HEADER_HEIGHT})`, 'important');
                el.style.setProperty('max-height', `calc(100vh - ${HEADER_HEIGHT})`, 'important');
                
            } else {
                // Optional: Reset styles for mobile if necessary
                el.style.removeProperty('height');
                el.style.removeProperty('max-height');
            }
        }
    };

    // 2. MONITORING LOGIC
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                forceStyle(mutation.target);
            }
        });
    });

    // 3. INITIALIZATION
    const checkExist = setInterval(() => {
        const menu = document.querySelector(MENU_SELECTOR);
        if (menu) {
            forceStyle(menu);
            // Watch for future attribute changes
            observer.observe(menu, { attributes: true });
            
            // Also force style on window resize to respect the 990px breakpoint
            window.addEventListener('resize', () => forceStyle(menu));
            
            clearInterval(checkExist);
        }
    }, 500);

    // Stop checking after 10 seconds to save performance
    setTimeout(() => clearInterval(checkExist), 10000);
})();